import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Callout = makeShortcode("Callout");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Provides two methods to continue or abort the payment.`}</p>
    <Callout variant='danger' mdxType="Callout">
      <p>{`You MUST call one of the methods of the handler if `}<inlineCode parentName="p">{`onBeforePaymentCreate`}</inlineCode>{` is implemented.`}</p>
    </Callout>
    <p>{`Choose to abort a payment.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`return handler.abortPaymentCreation()
`}</code></pre>
    <p>{`Choose to continue with payment creation`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`return handler.continuePaymentCreation()
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      